import { createLink } from '@tanstack/react-router'
import type { VariantProps } from 'class-variance-authority'
import { cn } from 'cn'
import type { ComponentProps } from 'react'
import { buttonVariants } from '../ui/button'
import styles from './NavLink.module.css'

export type NavAnchorProps = ComponentProps<'a'> &
  VariantProps<typeof buttonVariants> & {
    current?: 'page' | true | false
  }

export function NavAnchor({
  variant = 'outline',
  size = 'sm',
  className,
  current,
  ...props
}: NavAnchorProps) {
  return (
    <a
      data-current={current ? '' : undefined}
      aria-current={current === true ? 'true' : current || undefined}
      className={buttonVariants({ variant, size, className: cn(styles.link, className) })}
      {...props}
    />
  )
}

export const NavLink = createLink(NavAnchor)
